import axios from '@/api/requests/axios'

export default {
  getStatistics: () => axios.get('/api/admin/v1/reports/statistics'),

  getDashboard: () => axios
    .get('/api/admin/v1/reports/dashboard', {
      stayOnForbidden: true,
      validateStatus: status => (status >= 200 && status < 300) || status === 404,
    })
    .then(response => (response.status === 404
      ? Promise.reject(Object.assign(new Error('dashboard is not found'), { response }))
      : response)),
  getDigitalCurrencyOrders: params => axios.post('/api/admin/v1/reports/digital-currency', params),
  getDigitalCurrencyByBranchOrders: params => axios.post('/api/admin/v1/reports/digital-currency-by-branch', params),
  getDigitalCurrencyOrdersFile: params => axios.post('/api/admin/v1/reports/digital-currency/file', params, { responseType: 'blob' }),
  getDigitalCurrencyByBranchOrdersFile: params => axios.post('/api/admin/v1/reports/digital-currency-by-branch/file', params, { responseType: 'blob' }),
  getOperatorReport: params => axios.post('/api/admin/v1/reports/operators', params),
  getOperatorReportFile: params => axios.post('/api/admin/v1/reports/operators/file', params, { responseType: 'blob' }),
  getPaymentReconciliation: params => axios.post('/api/admin/v1/reports/payment-reconciliation', params),
  getPaymentReconciliationFile: params => axios.post('/api/admin/v1/reports/payment-reconciliation/file', params, { responseType: 'blob' }),

  getPaymentReconciliationCase: orderId => axios.get(`/api/admin/v1/reports/payment-reconciliation/${orderId}/case`),
  setPaymentReconciliationCaseStatus: (orderId, status) => axios
    .put(`/api/admin/v1/reports/payment-reconciliation/${orderId}/case/status`, { status }),
  addPaymentReconciliationComment: (orderId, text) => axios
    .post(`/api/admin/v1/reports/payment-reconciliation/${orderId}/case/comments`, { text }),
  syncOrders: params => axios.post('/api/admin/v1/reports/sync-by-period', params),
}
